import React from 'react';
import { LanguageProvider } from './LanguageContext';
import Navbar from './components/Navbar';
import HeroScroll from './components/HeroScroll';
import About from './components/About';
import Tickets from './components/Tickets';
import BusinessTravel from './components/BusinessTravel';
import FloorPlan from './components/FloorPlan';
import UltraLongRange from './components/UltraLongRange';
import BetterWay from './components/BetterWay';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="app">
        <Navbar />
        <HeroScroll />
        <About />
        <Tickets />
        <BusinessTravel />
        <FloorPlan />
        <UltraLongRange />
        <BetterWay />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;